<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>门店费用设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            show-checkbox
            @check="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div style="rgb(222,222,222);width: 100%;height: 600px;">
        <el-button size="mini" @click="showCostDialog">新建门店费用</el-button>
        <el-button size="mini" @click="createOrgCost">机构配置门店费用</el-button>
        <el-card style="height: 550px;">
          <el-checkbox-group v-model="orgCost.costIds" size="small">
            <el-checkbox v-for="(cost,index) in costs"
                         :label="cost.id"
                         :key="index">
              {{cost.costCnName}}
            </el-checkbox>
          </el-checkbox-group>
        </el-card>
        <br>
      </div>
    </div>

    <el-dialog
      title="新建门店费用"
      :visible.sync="costDialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;justify-content: space-around;align-items: center;margin-top: 20px">
        <span>门店费用名称：</span>
        <el-input size="mini" v-model="cost.costCnName" style="width: 70%"/>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeCostDialog">取 消</el-button>
          <el-button size="mini" @click="createCost">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data(){
    return{
      orgList: [],
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      costDialogVisible:false,
      costs:[],
      orgCosts:[],
      cost:{
        costCnName:'',
        creator:'',
        costType:''
      },
      orgCost:{
        orgIds:[],
        costIds:[],
        costType:''
      },
      selectOrgId:'',
      authorities:'',
    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //组织机构树点击节点方法
    handleCheckChange(data) {
      this.selectOrgId = data.id;
      this.loadOrgCosts();
    },
    async loadOrgCosts(){
      const {data:res} = await this.$http.get(`/cost/select/orgId/${this.selectOrgId}/costType/${3}`);
      this.orgCost.costIds = res.data;
    },
    showCostDialog(){
      this.cost.costCnName ='';
      this.costDialogVisible = true;
    },
    closeCostDialog(){
      this.costDialogVisible = false;
    },
    // 加载机构树
    async loadOrg(){
      // const {data:res} = await this.$http.get(`/orgs/areaList/orgId/${this.orgId}`);
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async loadCosts(){
      const {data:res} = await this.$http.get(`/cost/${3}`);
      this.costs = res.data;
    },
    async createCost(){
      if (this.cost.costCnName === ''){
        return this.$message.warning("请填写内容！");
      }
      this.cost.creator = this.userId;
      this.cost.costType = 3;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/cost/add`, this.cost);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadCosts();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeCostDialog();
    },
    async createOrgCost(){
      this.orgCost.orgIds = this.$refs.tree.getCheckedKeys();
      if (this.orgCost.orgIds.length === 0){
        return this.$message.warning("请选择机构！")
      }
      if (this.orgCost.costIds.length === 0){
        return this.$message.warning("请选择支出类型！")
      }
      this.orgCost.costType = 3;
      const {data:res} = await this.$http.post(`/cost/addOrgCost`, this.orgCost);
      await this.loadOrgCosts();
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
    this.loadCosts();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ShopCostSet.vue